import React from 'react'
import { useOutletContext } from 'react-router-dom'
import { Card, Typography, Flex, Alert, Select } from 'antd'
import type { FlowEditorContext } from '../../index'
import { chatRedirectOptions } from '@/data'

const { Title, Text } = Typography

export const ChatPage: React.FC = () => {
  const { selectedTemplate, linkedChatId, setLinkedChatId } =
    useOutletContext<FlowEditorContext>()

  if (!selectedTemplate) {
    return (
      <Alert
        title="No Template Selected"
        description="Please select a template first to edit content."
        type="info"
        showIcon
      />
    )
  }

  return (
    <div>
      <Flex vertical gap="large" style={{ width: '100%' }}>
        <div>
          <Title level={4}>Chat</Title>
          <Text type="secondary">
            Select which chat configuration to use for this lead flow.
          </Text>
        </div>

        <Card title="Select Chat" style={{ maxWidth: 700 }}>
          <Select
            placeholder="Select a chat..."
            value={linkedChatId}
            onChange={(value) => setLinkedChatId(value)}
            style={{ width: '100%' }}
            size="large"
            options={chatRedirectOptions}
          />
        </Card>
      </Flex>
    </div>
  )
}
